import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

/**
 * @file 数组与常用方法
 * @author alfielv
 */
import _ from 'lodash';
import { useMemo, useRef } from 'react';
import useForceUpdate from '../useForceUpdate';
export default (function (initialList) {
  // 用ref保证每次执行完api，能立即得到最新list
  var listRef = useRef(_.isFunction(initialList) ? initialList() : initialList);
  var forceUpdate = useForceUpdate();
  var actions = useMemo(function () {
    return {
      set: function set(newList) {
        listRef.current = newList;
        forceUpdate();
      },
      push: function push() {
        for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
          items[_key] = arguments[_key];
        }

        if (items.length <= 0) {
          console.error('Invalid parameter error! useList actions.push expect params.length > 0!');
        } else {
          actions.set([].concat(_toConsumableArray(listRef.current), items));
        }
      },
      updateAt: function updateAt(index, item) {
        var list = listRef.current;
        var listLength = list.length;

        if (index < 0 || index > listLength) {
          console.error('Invalid parameter error! useList actions.updateAt expect a valid index!');
        } else {
          var retList = _toConsumableArray(listRef.current);

          retList[index] = item;
          actions.set(retList);
        }
      },
      insertAt: function insertAt(index, item) {
        if (index < 0) {
          console.error('Invalid parameter error! useList actions.insertAt expect a valid index!');
        } else {
          var retList = _toConsumableArray(listRef.current);

          index > retList.length ? retList[index] = item : retList.splice(index, 0, item);
          actions.set(retList);
        }
      },
      removeAt: function removeAt(index) {
        var list = listRef.current;
        var listLength = list.length;

        if (index < 0 || index > listLength) {
          console.error('Invalid parameter error! useList actions.removeAt expect a valid index!');
        } else {
          var retList = _toConsumableArray(list);

          retList.splice(index, 1);
          actions.set(retList);
        }
      },
      clear: function clear() {
        actions.set([]);
      },
      reset: function reset() {
        actions.set(initialList);
      },
      customUpdate: function customUpdate(updateFunction) {
        actions.set(updateFunction(listRef.current));
      } // eslint-disable-next-line react-hooks/exhaustive-deps

    };
  }, []);
  return [listRef.current, actions];
});